import classNames from 'classnames';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import HoverCard from 'components/HoverCard';
import { LargeUp, Medium, Small } from 'components/MediaQuery';
import { largeUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

import Colorway from './Colorway';
import DesktopSizeSelector from './DesktopSizeSelector';
import MobileSizeSelector from './MobileSizeSelector';

const ColorwayCard = class extends React.Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
  }

  openSizeSelector = () => this.setState({ isOpen: true });

  closeSizeSelector = () => this.setState({ isOpen: false });

  toggleSizeSelector = () =>
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));

  handleEnterKeyUp = e => {
    if (e.key === 'Enter') {
      this.toggleSizeSelector();
    }
  };

  render() {
    const {
      colorway,
      onSizeSelection,
      trackNavigation,
      enableDiscountPriceColor,
      hasMobileQuickAddRow,
    } = this.props;
    const { isOpen } = this.state;

    return (
      <div
        className={classNames('ColorwayCard', {
          'ColorwayCard--sizes': isEmpty(colorway.sortedSizes),
        })}
      >
        <LargeUp>
          <HoverCard
            top={Theme.get('spacing') * 4}
            right={Theme.get('spacing') * 4}
            bottom={Theme.get('spacing') * 4}
            left={Theme.get('spacing') * 4}
            onKeyUp={this.handleEnterKeyUp}
            onBlur={this.closeSizeSelector}
            onMouseEnter={this.openSizeSelector}
            onMouseLeave={this.closeSizeSelector}
            aria-expanded={isOpen}
          >
            <Colorway
              {...colorway}
              isDesktop
              trackNavigation={trackNavigation}
              enableDiscountPriceColor={enableDiscountPriceColor}
            />
            {isOpen && !isEmpty(colorway.sortedSizes) && (
              <DesktopSizeSelector
                sortedSizes={colorway.sortedSizes}
                onSizeSelection={onSizeSelection}
                type={colorway.type}
              />
            )}
          </HoverCard>
        </LargeUp>
        <Medium>
          <Colorway
            {...colorway}
            isDesktop={false}
            trackNavigation={trackNavigation}
            enableDiscountPriceColor={enableDiscountPriceColor}
          />
          {!isEmpty(colorway.sortedSizes) && !hasMobileQuickAddRow ? (
            <MobileSizeSelector
              sortedSizes={colorway.sortedSizes}
              onSizeSelection={onSizeSelection}
              type={colorway.type}
            />
          ) : null}
        </Medium>
        <Small>
          <Colorway
            {...colorway}
            isDesktop={false}
            trackNavigation={trackNavigation}
            enableDiscountPriceColor={enableDiscountPriceColor}
          />
          {!isEmpty(colorway.sortedSizes) && !hasMobileQuickAddRow ? (
            <MobileSizeSelector
              sortedSizes={colorway.sortedSizes}
              onSizeSelection={onSizeSelection}
              type={colorway.type}
            />
          ) : null}
        </Small>
        <style jsx>
          {`
            .ColorwayCard {
              width: 100%;
              height: 100%;
              position: relative;
              background-color: ${Theme.get('colors-white')};
            }

            @media ${largeUp} {
              .ColorwayCard {
                background-color: none;
              }
            }
          `}
        </style>
        <style jsx global>
          {`
            .ColorwayCard.ColorwayCard--sizes .ShadowBox {
              padding-bottom: ${Theme.get('spacing') * 2}px;
            }

            .ColorwayCard .HoverCard,
            .ColorwayCard .HoverCard .HoverCard__children {
              height: 100%;
            }
          `}
        </style>
      </div>
    );
  }
};

ColorwayCard.propTypes = {
  colorway: PropTypes.shape(Colorway.propTypes).isRequired,
  enableDiscountPriceColor: PropTypes.bool,
  hasMobileQuickAddRow: PropTypes.bool,
  onSizeSelection: PropTypes.func,
  trackNavigation: PropTypes.func,
};

ColorwayCard.defaultProps = {
  enableDiscountPriceColor: false,
  onSizeSelection: () => {},
  trackNavigation: () => {},
};

export default ColorwayCard;
